import { PropsWithChildren } from "react";
import { clsx } from "clsx";

/**
 * 自适应容器
 * @param props
 * @constructor
 */
export function AutoContainer(
  props: PropsWithChildren & {
    className?: string;
    showHeader?: boolean;
    title?: string;
    route?: string;
  },
) {
  return (
    <div className={clsx("min-h-[600px]", props.className)}>
      {/* 容器内容 */}
      {props.children}
    </div>
  );
}
